export const BackgroundColor = {
	lightGrey: "Light Grey"
}
